import React from "react";
import { Modal } from "react-bootstrap";
import ViewForm from "../../Components/ApplicantProcessing/ViewForm";

const VIEW_FORM_MODAL_STYLES = {
    modalContent: {
        borderRadius: "26px",
        overflow: "hidden",
        border: "1px solid rgba(226, 232, 240, 1)",
        boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)"
    },
    header: {
        padding: "18px 22px",
        borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
        background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)"
    },
    headerContent: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "14px"
    },
    modalFooter: {
        padding: "16px 22px 20px",
        borderTop: "1px solid rgba(226, 232, 240, 0.9)",
        background: "#ffffff"
    },
    titleWrap: {
        display: "flex",
        alignItems: "center",
        gap: "14px"
    },
    headerIcon: {
        width: "46px",
        height: "46px",
        borderRadius: "15px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
        color: "#4338ca",
        fontSize: "21px",
        boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)"
    },
    title: {
        fontSize: "22px",
        fontWeight: 800,
        color: "#0f172a",
        lineHeight: 1.1,
        margin: 0
    },
    subtitle: {
        fontSize: "12px",
        color: "#64748b",
        marginTop: "4px"
    },
    closeButton: {
        width: "38px",
        height: "38px",
        borderRadius: "999px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        color: "#64748b",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "16px",
        fontWeight: 800,
        boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
        flexShrink: 0
    },
    body: {
        padding: "20px 22px 22px 22px",
        background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
    },
    helperCard: {
        borderRadius: "16px",
        padding: "16px",
        background: "linear-gradient(135deg, rgba(248,250,252,0.98) 0%, rgba(239,246,255,0.9) 100%)",
        border: "1px solid rgba(191, 219, 254, 0.9)",
        marginBottom: "16px"
    },
    helperTitle: {
        fontSize: "14px",
        fontWeight: 800,
        color: "#0f172a",
        marginBottom: "8px"
    },
    helperText: {
        fontSize: "12px",
        lineHeight: 1.7,
        color: "#64748b",
        margin: 0
    },
    sectionCard: {
        borderRadius: "20px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
        padding: "18px",
        marginBottom: "16px"
    },
    formFrame: {
        height: "min(68vh, 640px)",
        overflow: "auto",
        borderRadius: "16px",
        border: "1px solid rgba(226, 232, 240, 1)",
        backgroundColor: "#ffffff"
    },
    formContent: {
        padding: "18px"
    },
    footerActions: {
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
        flexWrap: "wrap"
    },
    cancelButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        color: "#475569",
        padding: "10px 14px",
        fontSize: "12px",
        fontWeight: 800
    }
};

const ViewFormModal = (props) => {
    const { handleViewForm, viewFormShowHide,
        workflowTask, selectedForm, handleFormUpdate, allowEdit, formName = "" } = props;
    return (
        <Modal
            show={viewFormShowHide}
            centered
            dialogClassName="custom-inline-dialog"
            contentClassName="view-form-modal-content"
        >
            <style>
                {`
                  .custom-inline-dialog {
                    max-width: min(1120px, 92vw) !important;
                    width: min(1120px, 92vw) !important;
                  }

                  .view-form-modal-content {
                    border-radius: ${VIEW_FORM_MODAL_STYLES.modalContent.borderRadius};
                    overflow: ${VIEW_FORM_MODAL_STYLES.modalContent.overflow};
                    border: ${VIEW_FORM_MODAL_STYLES.modalContent.border};
                    box-shadow: ${VIEW_FORM_MODAL_STYLES.modalContent.boxShadow};
                  }
                `}
            </style>
            <Modal.Header style={VIEW_FORM_MODAL_STYLES.header}>
                <div style={VIEW_FORM_MODAL_STYLES.headerContent}>
                    <Modal.Title as="div" style={VIEW_FORM_MODAL_STYLES.titleWrap}>
                        <div style={VIEW_FORM_MODAL_STYLES.headerIcon}>
                            <i className={allowEdit ? "fa fa-pencil-square-o" : "fa fa-file-text-o"} aria-hidden="true"></i>
                        </div>
                        <div>
                            <div style={VIEW_FORM_MODAL_STYLES.title}>{formName || "Form Details"}</div>
                            <div style={VIEW_FORM_MODAL_STYLES.subtitle}>
                                {allowEdit ? "Review the form details and make updates where editing is enabled." : "Review the submitted form details in read-only mode."}
                            </div>
                        </div>
                    </Modal.Title>
                    <button
                        type="button"
                        style={VIEW_FORM_MODAL_STYLES.closeButton}
                        onClick={handleViewForm}
                        aria-label="Close form popup"
                    >
                        <i className="fa fa-times" aria-hidden="true"></i>
                    </button>
                </div>
            </Modal.Header>
            <Modal.Body style={VIEW_FORM_MODAL_STYLES.body}>
                <div style={VIEW_FORM_MODAL_STYLES.helperCard}>
                    <div style={VIEW_FORM_MODAL_STYLES.helperTitle}>Form review</div>
                    <p style={VIEW_FORM_MODAL_STYLES.helperText}>
                        Check the submitted details below. When edit access is enabled, update the necessary fields and save from inside the form.
                    </p>
                </div>

                <div style={VIEW_FORM_MODAL_STYLES.sectionCard}>
                    <div style={VIEW_FORM_MODAL_STYLES.formFrame}>
                        <div style={VIEW_FORM_MODAL_STYLES.formContent}>
                            <ViewForm
                                formShowHide={viewFormShowHide}
                                handleFormShowHide={handleViewForm}
                                workflowTask={workflowTask}
                                selectedForm={selectedForm}
                                handleFormUpdate={handleFormUpdate}
                                allowEdit={allowEdit}
                            ></ViewForm>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer style={VIEW_FORM_MODAL_STYLES.modalFooter}>
                <div style={VIEW_FORM_MODAL_STYLES.footerActions}>
                    <button
                        type="button"
                        style={VIEW_FORM_MODAL_STYLES.cancelButton}
                        onClick={handleViewForm}
                    >
                        <i className="fa fa-times" aria-hidden="true"></i>
                        Close
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );

}

export default ViewFormModal;
